import { UST_DATABASE } from "@/lib/tank";

// Permits give gallons only, so pick the most common width for that size (fiberglass, nearest 96").
export function guessShape(cap) {
  const near = [...new Set(UST_DATABASE.map((t) => t.capacity))].sort((a, b) => Math.abs(a - cap) - Math.abs(b - cap))[0];
  const pool = UST_DATABASE.filter((t) => t.capacity === near);
  const pick = [...pool].sort((a, b) => (a.ends === "dome" ? 0 : 1) - (b.ends === "dome" ? 0 : 1) || Math.abs(a.diameter - 96) - Math.abs(b.diameter - 96))[0];
  return { diameter: pick.diameter, ends: pick.ends };
}

export function productFor(substance) {
  const s = (substance || "").toLowerCase();
  if (s.includes("diesel")) return "Diesel #2 (ULSD)";
  if (s.includes("kerosene")) return "Kerosene";
  if (s.includes("premium")) return "Premium 93";
  if (s.includes("mid")) return "Midgrade 89";
  return "Regular 87";
}

export function siteFromPermit(fac, tanks) {
  const usable = tanks.filter((x) => x.isOpen && x.capacity).slice(0, 12);
  return {
    name: fac.name.slice(0, 80),
    lat: fac.lat ?? null, lng: fac.lng ?? null, epaFacilityId: fac.facilityId,
    tanks: usable.map((x, i) => ({
      label: `T${i + 1} ${(x.substance || "Fuel").split(/[;,]/)[0].trim()}`.slice(0, 40),
      capacity: x.capacity, ...guessShape(x.capacity), startInches: 0, product: productFor(x.substance), epaTankId: x.tankId,
    })),
  };
}

const isDiesel = (txt) => /diesel/i.test(txt || "");

// What the EPA list says about the saved tank you're about to drop into.
export function epaVerdict(tank, data, t) {
  const fac = data?.facility;
  if (!fac) return null;
  const where = t("EPA list for {s}", { s: fac.name });
  if (fac.open === 0) return { level: "danger", text: `${where}: ${t("no open tanks. This store may be out of service.")}` };
  const byId = tank.epaTankId && data.tanks.find((x) => x.tankId === tank.epaTankId);
  if (byId) {
    return byId.isOpen ? { level: "ok", text: `${where}: ${t("this tank is open.")}` }
      : { level: "danger", text: `${where}: ${t("this tank ({id}) is marked {st}.", { id: byId.tankId, st: byId.status })}` };
  }
  const diesel = (tank.product || "").toLowerCase().includes("diesel");
  const alike = data.tanks.filter((x) => x.capacity && Math.abs(x.capacity - tank.capacity) <= tank.capacity * 0.05 && isDiesel(x.substance) === diesel);
  if (alike.length && !alike.some((x) => x.isOpen)) {
    return { level: "danger", text: `${where}: ${t("every {c} gal {p} tank is marked {st}.", { c: Math.round(tank.capacity).toLocaleString("en-US"), p: diesel ? "diesel" : "gas", st: alike[0].status })}` };
  }
  const off = data.tanks.filter((x) => x.outOfService);
  if (off.length) return { level: "caution", text: `${where}: ${t("out of service: {n}. Make sure it isn't this tank.", { n: off.length })}` };
  return { level: "ok", text: `${where}: ${t("tanks in service.")}` };
}
